import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useRoleShowState() {
  return useAppState();
}

export function useRoleShowActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      role: null,
      roleEditModalIsOpen: false,
      addRestrictedActionModalIsOpen: false,
      addUserToRoleModalIsOpen: false,
      newRestrictedAction: {
        id: '',
      },
      newUser: {
        id: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openRoleEditModal() {
    dispatch((appState) => ({
      ...appState,
      roleEditModalIsOpen: true,
    }));
  }

  function closeRoleEditModal() {
    dispatch((appState) => ({
      ...appState,
      roleEditModalIsOpen: false,
    }));
  }

  function openAddRestrictedActionModal() {
    dispatch((appState) => ({
      ...appState,
      addRestrictedActionModalIsOpen: true,
    }));
  }

  function closeAddRestrictedActionModal() {
    dispatch((appState) => ({
      ...appState,
      addRestrictedActionModalIsOpen: false,
      newRestrictedAction: { id: '' },
    }));
  }

  function openAddUserToRoleModal() {
    dispatch((appState) => ({
      ...appState,
      addUserToRoleModalIsOpen: true,
    }));
  }

  function closeAddUserToRoleModal() {
    dispatch((appState) => ({
      ...appState,
      addUserToRoleModalIsOpen: false,
      newUser: { id: '' },
    }));
  }

  function updateNewRestrictedActionId(restrictedActionId) {
    dispatch((appState) => ({
      ...appState,
      newRestrictedAction: {
        id: restrictedActionId,
      },
    }));
  }

  function updateNewUserId(userId) {
    dispatch((appState) => ({
      ...appState,
      newUser: {
        id: userId,
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openRoleEditModal,
    closeRoleEditModal,
    openAddRestrictedActionModal,
    closeAddRestrictedActionModal,
    openAddUserToRoleModal,
    closeAddUserToRoleModal,
    updateNewRestrictedActionId,
    updateNewUserId,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
